export const theme = 'saba';

export const slideOptions = (swiperRef, count) => ({
  observer: true,
  slidesOffsetAfter: 20,
  slidesOffsetBefore: 20,
  observeParents: true,
  spaceBetween: 22,
  watchOverflow: true,
  centeredSlidesBounds: true,
  centerInsufficientSlides: true,
  breakpoints: {
    320: {
      slidesPerView: 1.6,
      spaceBetween: 12,
      scrollbar: {
        dragSize: 62,
      },
      slidesOffsetAfter: count <= 1.6 ? 0 : 20,
      slidesOffsetBefore: count <= 1.6 ? 0 : 20,
      allowTouchMove: !(count <= 1.6),
    },
    680: {
      slidesPerView: 2.5,
      spaceBetween: 12,
      scrollbar: {
        dragSize: 166,
      },
      slidesOffsetAfter: count <= 2.5 ? 0 : 40,
      slidesOffsetBefore: count <= 2.5 ? 0 : 40,
      allowTouchMove: !(count <= 2.5),
    },
    1120: {
      slidesPerView: 3.7,
      slidesOffsetAfter: count <= 3.7 ? 0 : 40,
      slidesOffsetBefore: count <= 3.7 ? 0 : 40,
      allowTouchMove: !(count <= 3.7),
      spaceBetween: 25,
      scrollbar: {
        dragSize: 190,
      },
    },
    1920: {
      slidesPerView: 5.5,
      slidesOffsetAfter: count <= 5.5 ? 0 : 40,
      slidesOffsetBefore: count <= 5.5 ? 0 : 40,
      allowTouchMove: !(count <= 5.5),
      spaceBetween: 25,
      scrollbar: {
        dragSize: 190,
      },
    },
  },
  onSwiper: (swiper) => {
    swiperRef.current = swiper;
  },
});
